/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/time';
import '../banking/account_model';
import '../banking/common';
import './instruments';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankc": {
        "nested": {
          "BalanceProvider": {
            "values": {
              "UNKNOWN_BALANCE_PROVIDER_DO_NOT_USE": 0,
              "BANKLIN": 1,
              "LEDGER": 2,
              "VIRTUAL": 3,
              "SFS_CORE": 5,
              "BANKLIN_CASH": 7,
              "CAPITAL_CREDIT_CARD": 8,
              "CAPITAL_LOAN": 9,
              "BANKING_FOLDER": 10,
              "BANKLIN_C4B": 11,
              "PERCENTAGE_PROCESSING": 12,
              "INSTANT_ACCESS": 13,
              "CLEARING_ACCOUNT": 14,
              "RESERVES": 15,
              "SQUARE_BITCOIN": 16,
              "EMPLOYEE_TIP_CASH_PAYOUT": 17
            }
          },
          "BalanceOwnershipToken": {
            "fields": {
              "type": {
                "type": ".squareup.bankc.BalanceOwnershipToken.Type",
                "id": 1,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN_BALANCE_OWNERSHIP_TYPE_DO_NOT_USE": 0,
                  "MERCHANT": 1,
                  "UNIT": 2
                }
              }
            }
          },
          "BalanceSummary": {
            "fields": {
              "balanceId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "balanceProvider": {
                "type": ".squareup.bankc.BalanceProvider",
                "id": 2,
                "rule": "optional"
              },
              "availableBalance": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "pendingSettlementTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "balanceOwnershipToken": {
                "type": ".squareup.bankc.BalanceOwnershipToken",
                "id": 5,
                "rule": "optional"
              },
              "accountMetadata": {
                "type": ".squareup.banking.AccountMetadata",
                "id": 6,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.banking.AccountState",
                "id": 7,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "balanceInstruments": {
                "type": ".squareup.bankc.BalanceInstrument",
                "id": 9,
                "rule": "repeated"
              },
              "isFrozen": {
                "type": "bool",
                "id": 10,
                "rule": "optional"
              },
              "isDeactivated": {
                "type": "bool",
                "id": 11,
                "rule": "optional"
              },
              "isClosed": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "isSettleableForSweeping": {
                "type": "bool",
                "id": 13,
                "rule": "optional",
                "options": {
                  "default": true
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankc?.nested?.BalanceProvider && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceOwnershipToken && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceOwnershipToken?.nested?.Type && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceSummary) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BalanceProvider @ squareup/bankc/model.proto at 61:1
 */
export const BalanceProvider = $root.lookupEnum('squareup.bankc.BalanceProvider').values;
/**
 * SOURCE BalanceOwnershipToken @ squareup/bankc/model.proto at 989:1
 */
export const BalanceOwnershipToken = $root.lookupType('squareup.bankc.BalanceOwnershipToken');
fixType(BalanceOwnershipToken);
Builder.createAndAttachToType(BalanceOwnershipToken);
/**
 * SOURCE Type @ squareup/bankc/model.proto at 990:3
 */
BalanceOwnershipToken.Type = $root.lookupEnum('squareup.bankc.BalanceOwnershipToken.Type').values;
/**
 * Canonical representation of a balance. Includes both fields related to the general state of
 * a balance (stored within Bankc's db) as well as fields related to its real-time state
 * (stored at the balance provider, requires a further downstream RPC/API call to populate).
 * Depending on the on endpoint, fields about the balance's real-time state are not guaranteed
 * to be populated.
 *
 * SOURCE BalanceSummary @ squareup/bankc/model.proto at 1006:1
 */
export const BalanceSummary = $root.lookupType('squareup.bankc.BalanceSummary');
fixType(BalanceSummary);
Builder.createAndAttachToType(BalanceSummary);